<template>

  <!-- CART DROPDOWN -->
  
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <feather-icon icon="ClockIcon" class="cursor-pointer ml-4 mr-6 mt-1"  />
      <vs-dropdown-menu class="cart-dropdown vx-navbar-dropdown" >
            <vx-card title="Timekeeping Manager" >
                 <vs-input class="hidden" v-model="employeeScheduleId" />
                <vs-button class="mt-2 mr-3 shadow-lg" :color="!isBreak && !isDisabled ? 'success' : isDisabled && !isBreak ? 'warning' : 'primary'" type="gradient" gradient-color-secondary="#78E395"  @click=" !isBreak && !isDisabled ? onClockIn() : onBreakOut() ">{{ !isBreak && !isDisabled ? 'Clock-In' : isDisabled && !isBreak ? 'Break-Out' : 'Resume'}}</vs-button>
                <vs-button class="mt-2 mr-3 shadow-lg" color="danger" type="gradient" gradientColorSecondary="#f77777" @click="onClockOut()" :disabled="!isDisabled">Clock-Out</vs-button>
            </vx-card>

      </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import moment from 'moment'
export default {

  data () {
    return {
        employeeFiledTimeSheetId    : null,
        // employeeScheduleId          : null,
        segmentTypeId               : 0,
        badgeTimeIn                 : null,
        badgeTimeOut                : null,
        reason                      : '',
        isManualAdded               : false,
        addedOn                     : null,
        ipAddress                   : '',
        latitude                    : 0.0,
        longitude                   : 0.0,
        tzOffset                    : '',
        tzName                      : '',
        tzDST                       : true,
        deviceId                    : '',
        deviceName                  : '',
        deviceOS                    : '',
        remarks                     : '',
        photoId                     : '',
        subscriptionId              : '',
        approversTKs                : [],

        myInterval: null,

        ipAddress: '',
        latitude: 0,
        longitude:0,
        currdate: moment().format('YYYY-MM-DD'),
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  created() {
      this.getCurrentSchedule()
  },
  computed: {

      
      isDisabled() { return this.$store.state.timekeeping.isDisabled },
      isBreak() { return this.$store.state.timekeeping.isBreak },
      
      
      // clockIn() { return this.$store.state.timekeeping.clockIn},
  },
  methods: {
      getCurrentSchedule(userId = '') {
          var curDate = new Date()
          var dateToday = moment(this.curDate).format('YYYY-MM-DD')
          // Loading
          this.$vs.loading()

          const payload = {
            scheduleDate: dateToday,
            userId: userId
          }

          //Schedule
          this.$store.dispatch('timekeeping/getScheduleByDate', payload)
          .then((response) => { 
              this.$vs.loading.close() })
          .catch((error) => {this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })

      },
      onClockIn() {
          // this.getCurrentSchedule()
          this.getCurrentLocation()
          this.getUserIPAddress()
          const obj = {
            employeeScheduleId  : this.scheduleId,
            segmentTypeId       : 2,
            badgeTimeIn         : moment().format('MM/DD/YYYY hh:mm:ss A'),
            badgeTimeOut        : moment().format('MM/DD/YYYY hh:mm:ss A'),
            reason              : this.reason,
            isManualAdded       : this.isManualAdded,
            addedOn             : this.addedOn,
            ipAddress           : this.ipAddress,
            latitude            : this.latitude,
            longitude           : this.longitude,
            tzOffset            : this.tzOffset,
            tzName              : this.tzName,
            tzDST               : this.tzDST,
            deviceId            : this.deviceId,
            deviceName          : this.deviceName,
            deviceOS            : this.deviceOS,
            remarks             : this.remarks,
            photoId             : this.photoId,
            subscriptionId      : this.subscriptionId,
            approversTKs        : this.approversTKs
          }
          this.$store.dispatch('timekeeping/addSegment', obj)
          .then(res => {})
          .catch(err => { console.error(err) })
      },
      onClockOut() {

          const obj = {
            employeeScheduleId  : this.scheduleId,
            segmentTypeId       : 3,
            badgeTimeIn         : moment().format('MM/DD/YYYY hh:mm:ss A'),
            badgeTimeOut        : moment().format('MM/DD/YYYY hh:mm:ss A'),
            reason              : this.reason,
            isManualAdded       : this.isManualAdded,
            addedOn             : this.addedOn,
            ipAddress           : this.ipAddress,
            latitude            : this.latitude,
            longitude           : this.longitude,
            tzOffset            : this.tzOffset,
            tzName              : this.tzName,
            tzDST               : this.tzDST,
            deviceId            : this.deviceId,
            deviceName          : this.deviceName,
            deviceOS            : this.deviceOS,
            remarks             : this.remarks,
            photoId             : this.photoId,
            subscriptionId      : this.subscriptionId,
            approversTKs        : this.approversTKs
          }

          this.$store.dispatch('timekeeping/addSegment', obj)
          .then(res => {})
          .catch(err => { console.error(err) })
      },
      onBreakOut(){
        if(this.$store.state.timekeeping.isDisabled && !this.$store.state.timekeeping.isBreak)
        {

          const obj = {
            employeeScheduleId  : this.scheduleId,
            segmentTypeId       : 4,
            badgeTimeIn         : moment().format('MM/DD/YYYY hh:mm:ss A'),
            badgeTimeOut        : moment().format('MM/DD/YYYY hh:mm:ss A'),
            reason              : this.reason,
            isManualAdded       : this.isManualAdded,
            addedOn             : this.addedOn,
            ipAddress           : this.ipAddress,
            latitude            : this.latitude,
            longitude           : this.longitude,
            tzOffset            : this.tzOffset,
            tzName              : this.tzName,
            tzDST               : this.tzDST,
            deviceId            : this.deviceId,
            deviceName          : this.deviceName,
            deviceOS            : this.deviceOS,
            remarks             : this.remarks,
            photoId             : this.photoId,
            subscriptionId      : this.subscriptionId,
            approversTKs        : this.approversTKs
          }

          this.$store.dispatch('timekeeping/addSegment', obj)
          .then(res => {
            var startTimestamp  = moment().startOf("day");
            this.myInterval     = setInterval(function() {
              startTimestamp.add(1, 'second');
              document.getElementById('timer').innerHTML =
                  ' <strong class="ql-font-serif ql-size-large">' + startTimestamp.format('HH:mm:ss') + '</strong>';
            }, 1000);
          })
          .catch(err => { console.error(err) })
        }
        else //RESUME
        {

          const obj = {
            employeeScheduleId  : this.scheduleId,
            segmentTypeId       : 5,
            badgeTimeIn         : moment().format('MM/DD/YYYY hh:mm:ss A'),
            badgeTimeOut        : moment().format('MM/DD/YYYY hh:mm:ss A'),
            reason              : this.reason,
            isManualAdded       : this.isManualAdded,
            addedOn             : this.addedOn,
            ipAddress           : this.ipAddress,
            latitude            : this.latitude,
            longitude           : this.longitude,
            tzOffset            : this.tzOffset,
            tzName              : this.tzName,
            tzDST               : this.tzDST,
            deviceId            : this.deviceId,
            deviceName          : this.deviceName,
            deviceOS            : this.deviceOS,
            remarks             : this.remarks,
            photoId             : this.photoId,
            subscriptionId      : this.subscriptionId,
            approversTKs        : this.approversTKs
          }

          this.$store.dispatch('timekeeping/addSegment', obj)
          .then(res => {
            clearInterval(this.myInterval);
          })
          .catch(err => { console.error(err) })

        }


      },
      getCurrentLocation() {
        //console.log('dumaan dito sa location')
        if(navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            p => {
            this.latitude = p.coords.latitude
            this.longitude = p.coords.longitude
          },
            error => {
              console.log(error.message)
            })
        } else {
          //console.log('Your browser oes not support geolocation API')
        }
      },
      getUserIPAddress() {
        //console.log('dumaan dito sa IP')
        fetch('https://api.ipify.org?format=json')
        .then(x => x.json())
        .then(({ ip }) => {
            this.ipAddress = ip
            //console.log(ip)
        });
      },
      
  },
  components: {
    VuePerfectScrollbar
  },
}

</script>
